import { Container, ContentWrapper, TopBar, GogoxIMG, Title } from '@/modules/track-and-trace/track-and-trace.styles';
import { useTranslation } from 'next-i18next';
import TrackSearch from '@/modules/track-and-trace/track-search/track-search.component';
import { useLazySearchTrackingByOrderIdsQuery } from '@/modules/track-and-trace/track-and-trace.api';
import { useEffect, useState } from 'react';
import TrackRecordCard from '@/modules/track-and-trace/track-record-card/track-record-card.component';
import NoRecordCard from '@/modules/track-and-trace/track-record-card/no-record-card.component';
import { GgxLinearProgressbar } from '@gogovan/entier-web-core/components/ggx-linear-progressbar';
import RegionLanguageSelection from '@/modules/track-and-trace/region-language-selection/region-language-selection.component';
import FloatingChatButton from '@/utilities/reusable-components/button/floating-chat-button/floating-chat-button.component';

const TrackAndTrace = () => {
  const { t } = useTranslation('common');
  const [reqBody, setReqBody] = useState({ captchaToken: '', orderIds: [], locale: '' });
  const [trackResults, setTrackResults] = useState([]);
  const [captchaToken, setCaptchaToken] = useState('');
  const [trigger, { data, isFetching }] = useLazySearchTrackingByOrderIdsQuery({
    orderIds: reqBody,
    captchaToken,
    locale: '',
    urlIdentifier: '',
  });

  useEffect(() => {
    if (reqBody && reqBody.captchaToken.length > 0 && reqBody.urlIdentifier) {
      trigger(reqBody);
    }
  }, [reqBody]);

  useEffect(() => {
    if (data && data.data) {
      setTrackResults([]);
      reqBody.orderIds.forEach((searchId) => {
        if (data.data[searchId]) {
          setTrackResults((oldResult) => [
            ...oldResult,
            <TrackRecordCard key={searchId} trackingRecords={data.data[searchId]} />,
          ]);
        } else {
          setTrackResults((oldResult) => [...oldResult, <NoRecordCard key={searchId} trackingId={searchId} />]);
        }
      });
    }
  }, [data]);

  return (
    <Container>
      <TopBar>
        <GogoxIMG />
        <RegionLanguageSelection />
      </TopBar>
      <ContentWrapper>
        <Title>{t('track_and_trace')}</Title>
        <TrackSearch setReqBody={setReqBody} setCaptchaToken={setCaptchaToken} isSearching={isFetching} />
        {isFetching && <GgxLinearProgressbar sx={{ margin: '0 48px' }} />}
        {trackResults.map((trackResult) => trackResult)}
      </ContentWrapper>
      <FloatingChatButton />
    </Container>
  );
};

export default TrackAndTrace;
